<template>
  <div class="centent">
    <div :class="{ streeKeyformShow: streeKeyformShow }" class="titlefont">
      <div class="titleAnimation">
        <div class="title">无基础“升职加薪” 转行“跳槽大厂”</div>
        <div class="desc">
          <span>你缺的只是一个好项目</span>
        </div>
      </div>
    </div>
    <div class="cont" :class="{ streeKeyformShow: streeKeyformShow }">
      <div class="contInfo itemA">
        <div class="centImg">
          <div>
            <img src="./../images/pic01.png" width="594px" alt="" />
          </div>
          <div>
            <img src="./../images/pic02.png" width="594px" alt="" />
          </div>
          <div>
            <img src="./../images/pic03.png" width="594px" alt="" />
          </div>
        </div>
        <div class="conText">
          <div class="textBox">
            <div class="title">竞争力——项目</div>
            <div class="method">
              <div class="tit"><span class="skillIcon"></span>技能</div>
              <p>拒绝理论派，用项目积累真实工作技能和经验</p>
            </div>
            <div class="method">
              <div class="tit"><span class="interviewIcon"></span>面试</div>
              <p>企业招聘主要看重项目经验，好项目能够增加面试成功率</p>
            </div>
          </div>
        </div>
      </div>
      <div class="iconTip itemG"></div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    streeKeyformShow: {
      type: Boolean,
      required: true,
      default: () => {},
    },
  },
  data() {
    return {
      navLiNum: 0,
    };
  },
  computed: {},
  created() {},
  mounted() {},
  methods: {},
};
</script>
<style src="./../style.scss" rel="stylesheet/scss" lang="scss" scoped></style>
<style lang="scss" scoped>
</style>
